exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3NLEz{position:relative;width:380px;height:184px;display:inline-block;vertical-align:top;border-radius:4px;margin:0 20px 0 0;-webkit-transition:.3s;-o-transition:.3s;transition:.3s}._3NLEz:last-child{margin-right:0}._3NLEz:hover{-webkit-box-shadow:0 10px 30px 0 rgba(0,0,0,.2);box-shadow:0 10px 30px 0 rgba(0,0,0,.2);-webkit-transform:translateY(-5px);-ms-transform:translateY(-5px);transform:translateY(-5px)}._1JsvI{position:absolute;top:0;left:0;width:380px;height:184px;border-radius:16px}._3pB7u{z-index:100;font-size:24px;color:#fff;position:relative;margin:20px 0 0 20px;font-weight:400;text-shadow:0 0 3px rgba(0,0,0,.3);height:61px;line-height:1.3;overflow:hidden;padding:0 20px 0 0}", ""]);

// exports
exports.locals = {
	"root": "_3NLEz",
	"img": "_1JsvI",
	"title": "_3pB7u"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/components/common/RecommendCard/index.css
// module id = 1231
// module chunks = 1